const getDietRecallScore = (questionId, userInput) => {
    const dietRecallMapping = {
        "sugar/honey/jaggery": 5,  // 1 tsp = 5g
        "biscuits": 5,             // 1 biscuit = 5g
        // "milk": 4.4,               // 100ml = 4.4g
        "milk" :4,
        "poha": 23,                // 1 bowl = 23g
        "sooji/rawa": 22,
        "museli/corn flakes": 30,
        "bread/paav": 15,
        "sabudana": 30,
        "oats": 30,
        "millet/other grains": 23,
        "fruit": 15,
        "fruit juice": 25,
        // "coconut water": 4.4,
        "coconut water": 4,
        "buttermilk": 0,
        "phulka": 10,
        "chapatis": 20,
        "bhakri": 30,
        // "paneer": 4.5,
        "paneer" : 4,
        "dal/sprouts": 16,
        "rice": 24,
        "cooked vegetable": 3,
        "indian sweets": 30,
        "rice puffs": 15,
        "cake/pastries/cookies/puffs": 35,
        "sugar in tea/coffee": 5,
        "vada paav": 35,
        "any other namkeen snack": 25,
        "mix seeds": 5,
        "chocolates/day": 6,
        "miscellaneous": 15,
    };

    // Normalize questionId to match mapping
    const normalize = (str) => 
        str.toLowerCase()
           .replace(/\s*\(.*?\)/g, '') // Remove text inside parentheses
           .replace(/etc\./g, '')      // Remove "etc."
           .replace(/\s+/, ' ')        // Normalize spaces
           .trim();

    const normalizedId = normalize(questionId);

    // Handle "any other" fields separately
    if (normalizedId.includes('how many units')) {
        return 30; // Return fixed 30g for any "any other" field
    }

    // For all other fields, multiply with user input
    return dietRecallMapping[normalizedId] ? userInput * dietRecallMapping[normalizedId] : 0;
};

export default getDietRecallScore;
